<template>
    
    <div 
        class="media-carousel"
        ref="carouselContainer"
        :style="{ paddingBottom: padding+'%', backgroundColor: backgroundColor}"
    >
        <ul class="slides" ref="slides">
            
            <li 
                class="slide"
                v-for="(item, index) in data.slides"
                :key="index"
                :class="{ 'active': index === currentSlide}"
            >
                <image-loader
                    :data="item.urls"
                    :containerWidth="containerWidth"
                    @loaded="imageLoaded"
                />
            </li>
        </ul>
    </div> 
    
</template>


<script>
import ImageLoader from '@/components/ImageLoader'
import Size from '@/plugins/WindowSize'
import Observer from '@/plugins/Observer'


export default {
    components: {
        ImageLoader,
    },
    
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {},
        }
    },
    
    data() {
        return {
            containerWidth: 0,
            currentSlide: 0,
            loadedSlides: 0,
            padding: 0,
            backgroundColor: '',
            isLoaded: false,
        }
    },
    
    created() {
        Size.addListener(this.onResize)
        this.backgroundColor = this.data.backgroundColor
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
        clearInterval(this.interval)
        
        this.observer.destroy()
    },
    
    mounted() {
        
        // Set aspect ratio depending on first image
        let as = this.data.slides[0].aspectRatio.split(":")
        let w = as[0]
        let h = as[1]
        this.aspectRatio = h/w;
        
        this.onResize()
        
        let options = {
            rootMargin: '0px', //'10px 0px 100px 0px',
            threshold: 0 // [0.1, 0.5, 0.9]
        }
        this.observer = new Observer(this.$refs.carouselContainer, this.onEnter, this.onLeave, options)
        
    },
    
    methods: {
        
        onEnter() {
            if (this.interval !== undefined) {
                clearInterval(this.interval)
            }
            this.interval = window.setInterval(this.repeatHandler, (this.data.timer*1000));
            // this.$refs.carouselContainer.style.visibility = 'visible'
        },
        
        onLeave() {
            clearInterval(this.interval)
            // this.$refs.carouselContainer.style.visibility = 'hidden'
        },
        
        imageLoaded() {
            this.loadedSlides++
            if (this.loadedSlides === this.data.slides.length) {
                this.componentLoaded()
            }
        },
        
        componentLoaded() {
            
            // Add loaded class
            this.$refs.slides.classList.add('loaded')
            this.isLoaded = true
            // Animate bg
            // this.backgroundColor = 'transparent'
            
            this.$emit('loaded')
        },
        
        repeatHandler() {
            this.currentSlide++
            if (this.currentSlide > this.data.slides.length-1) {
                this.currentSlide = 0
            }
        },
        
        onResize() {
            if (this.$refs.carouselContainer !== undefined) {
                
                this.containerWidth = this.$refs.carouselContainer.offsetWidth
                var containerHeight;
                
                // Round the height of images to closest 10, 20 or 30px.
                // This way we can assure that the grid items have same 
                // space beneath. Check rowHeight & rowSpan in Work.vue
                if (this.$router.currentRoute.name === 'Work' || this.$router.currentRoute.name === 'WorkFilter') {
                    var rowHeight = (window.innerWidth < 1024) ? 10 : (window.innerWidth < 1440) ? 20 : 30;
                    containerHeight = Math.round(this.containerWidth*this.aspectRatio / rowHeight) * rowHeight; // round off to each 20 - Fit the /work grid!
                }
                // Case page
                else {
                    containerHeight = this.containerWidth*this.aspectRatio;
                }
                
                this.padding = (containerHeight / this.containerWidth) * 100
            }
        },
    },
    
    computed: {
        isCaseFullWidth() {
            return this.$store.state.isCaseFullWidth
        },
    },
    
    watch: {
        isCaseFullWidth() {
            // Transition is playing - Wait until animation is done before updating image size
            if (this.resizeTimer) {
                window.clearTimeout(this.resizeTimer);
            }
            this.resizeTimer = window.setTimeout(this.onResize, 650) // Animation takes 600ms
        },
    },
    
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';


.media-carousel {
    width: 100%;
    height: 0;
    overflow: hidden; // if images in carousel have different aspect ratio
    // transition: background-color 1s;
    position: relative;
    
    .slides {
        position: absolute;
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: opacity 2s ease-out;
        
        &.loaded {
            opacity: 1;
        }
        
        .slide {
            visibility: hidden;
            
            &.active {
                visibility: visible;
            }
            
            img {
                position: absolute;
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
